import { render, staticRenderFns } from "./total.vue?vue&type=template&id=11fb1dd2&scoped=true"
import script from "./total.vue?vue&type=script&lang=js"
export * from "./total.vue?vue&type=script&lang=js"
import style0 from "./total.vue?vue&type=style&index=0&id=11fb1dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fb1dd2",
  null
  
)

export default component.exports